import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteProductMultiplierType($companyId: ID!, $id: ID!) {
    deleteProductMultiplierType(companyId: $companyId, id: $id) {
      productMultiplierType {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
